import { Component, OnInit } from '@angular/core';
import { HorizonToolService } from 'src/app/services/horizon-tool.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { TabsService } from 'src/app/services/tabsService';
import { CrossSectionService } from 'src/app/services/cross-section.service';

@Component({
  selector: 'app-horizon-tool',
  templateUrl: './horizon-tool.component.html',
  styleUrls: ['./horizon-tool.component.scss'],
  standalone: false
})
export class HorizonToolComponent implements OnInit {

  minMaxDepthDiff: number;

  constructor(
    public horizonToolController : HorizonToolService,
    public toolsService : ToolsControlService,
    public menuController : MenuManagementService,
    private globalSelectionService: GlobalSelectionControlService,
    public tabsService: TabsService,
    private crossSectionService : CrossSectionService
    ) {
  }

  private createHorizonLegendColors(){
    let colors = new Map<string, string>();
    colors.set("Screening Angle: [-90 - 0]", 'rgba(0, 255, 255, 1)' );
    colors.set("Screening Angle: [0 - 2]", 'rgba(255, 255, 0, 1)' );
    colors.set("Screening Angle: [2 - 4]", 'rgba(255, 136, 17, 1)' );
    colors.set("Screening Angle: [4 - 6]", 'rgba(255, 25, 25, 1)' );
    colors.set("Screening Angle: [6 - 90]", 'rgba(170, 0, 0, 1)' );
    this.globalSelectionService.horizonToolLayers.childLayers[0].horizon_tool_info = colors;
  }

  ngOnInit(): void {
    //default values
    this.createHorizonLegendColors();
    this.horizonToolController.horizonModal.minDepth = 1.0;
    this.horizonToolController.horizonModal.maxDepth = 50.0;
    this.horizonToolController.horizonModal.minStep = 1.0;
    this.horizonToolController.horizonModal.heigthAboveTerrain = 3.0; // meters
    this.minMaxDepthDiff = this.horizonToolController.horizonModal.maxDepth - this.horizonToolController.horizonModal.minDepth;
    this.createInputHandlers();
    this.horizonToolController.ctx = document.getElementById("canvas") as HTMLCanvasElement;
  }


  createInputHandlers(){
    // get HTML elements
    const centerLat = document.getElementById('centerLat');
    const centerLatCard = document.getElementById('centerLatCard');
    const centerLatDeg = document.getElementById('centerLatDeg');
    const centerLatMin = document.getElementById('centerLatMin');
    const centerLatSec = document.getElementById('centerLatSec');

    const centerLon = document.getElementById('centerLon');
    const centerLonCard = document.getElementById('centerLonCard');
    const centerLonDeg = document.getElementById('centerLonDeg');
    const centerLonMin = document.getElementById('centerLonMin');
    const centerLonSec = document.getElementById('centerLonSec');

    const minDepth = document.getElementById('minDepth');
    const maxDepth = document.getElementById('maxDepth');
    const minStep = document.getElementById('minStep');
    const height = document.getElementById('height');
    // functions to handle input events
    const transformToLatLonDMS = function(e) {
      if (e.target.name.includes("Lat")){
        this.horizonToolController.horizonModal.centerLatLonDms.fromLat(e.target.value);
      } else {
        this.horizonToolController.horizonModal.centerLatLonDms.fromLon(e.target.value);
      }
    }
    const transformToCoordinate = function(e) {
      if (e.target.name.includes("Lat")){
        if (e.target.name.includes("Card")){
          if (e.target.value == "N"){
            this.horizonToolController.horizonModal.centerLatLonDms.latitude.cardinal = "N";
          } else {
            this.horizonToolController.horizonModal.centerLatLonDms.latitude.cardinal = "S";
          }
        }
        this.horizonToolController.horizonModal.centerLatitude = Math.round(this.horizonToolController.horizonModal.centerLatLonDms.toLat() * 100000) / 100000;
      } else {
        if (e.target.name.includes("Card")){
          if (e.target.value == "E"){
            this.horizonToolController.horizonModal.centerLatLonDms.longitude.cardinal = "E";
          } else {
            this.horizonToolController.horizonModal.centerLatLonDms.longitude.cardinal = "W";
          }
        }
        this.horizonToolController.horizonModal.centerLongitude = Math.round(this.horizonToolController.horizonModal.centerLatLonDms.toLon() * 100000) / 100000;
      }
    }

    const handleParameters = function(e) {
      switch (e.target.id){
        case "minDepth":
          if (e.target.value < 0 ){
            this.horizonToolController.errorMessage[0] = "Parameter Min Depth cannot be less than 0";
            if (this.horizonToolController.horizonModal.maxDepth > 0){
              this.horizonToolController.errorMessage[1] = null;
            }
          } else if (e.target.value >= this.horizonToolController.horizonModal.maxDepth){
            this.horizonToolController.errorMessage[0] = "Parameter Min Depth cannot be greater than or equal to Max Depth";
            this.horizonToolController.errorMessage[1] = "Parameter Max Depth cannot be less than or equal to Min Depth";
          } else { // if input is correct
            this.horizonToolController.errorMessage[0] = null;
            this.horizonToolController.errorMessage[1] = null;
          }
          break;
        case "maxDepth":
          if (e.target.value <= 0 ){
            this.horizonToolController.errorMessage[1] = "Parameter Max Depth cannot be less than 1";
            if (this.horizonToolController.horizonModal.minDepth >= 0){
              this.horizonToolController.errorMessage[0] = null;
            }
          } else if ( e.target.value <= this.horizonToolController.horizonModal.minDepth){
            this.horizonToolController.errorMessage[1] = "Parameter Max Depth cannot be less than or equal to Min Depth";
            this.horizonToolController.errorMessage[0] = "Parameter Min Depth cannot be greater than or equal to Max Depth";
          } else { // if input is correct
            this.horizonToolController.errorMessage[1] = null;
            if (this.horizonToolController.horizonModal.minDepth >= 0){
              this.horizonToolController.errorMessage[0] = null;
            }
          }
          break;
        case "minStep":
          if (e.target.value < 1){
            this.horizonToolController.errorMessage[2] = "Parameter Interval cannot be less than 1";
          } else { // if input is correct
            this.horizonToolController.errorMessage[2] = null;
          }
          break;
        case "height" :
          if (e.target.value < 0){
            this.horizonToolController.errorMessage[3] = "Parameter Height Above Terrain cannot be less than 0";
          } else { // if input is correct
            this.horizonToolController.errorMessage[3] = null;
          }
          break;
      }
    }
    // input event listeners for latitude fields
    centerLat.addEventListener('input', transformToLatLonDMS.bind(this));
    centerLatCard.addEventListener('input', transformToCoordinate.bind(this));
    centerLatDeg.addEventListener('input', transformToCoordinate.bind(this));
    centerLatMin.addEventListener('input', transformToCoordinate.bind(this));
    centerLatSec.addEventListener('input', transformToCoordinate.bind(this));
    // input event listeners for longitude fields
    centerLon.addEventListener('input', transformToLatLonDMS.bind(this));
    centerLonCard.addEventListener('input', transformToCoordinate.bind(this));
    centerLonDeg.addEventListener('input', transformToCoordinate.bind(this));
    centerLonMin.addEventListener('input', transformToCoordinate.bind(this));
    centerLonSec.addEventListener('input', transformToCoordinate.bind(this));
    // input event listeners for parameters fields
    minDepth.addEventListener('input', handleParameters.bind(this));
    maxDepth.addEventListener('input', handleParameters.bind(this));
    minStep.addEventListener('input', handleParameters.bind(this));
    height.addEventListener('input', handleParameters.bind(this));
  }

  drawHorizonBtn(){
    this.horizonToolController.drawHorizonBtn();
  }

  callCrossSection(){
    this.tabsService.openNewToolsTab(TabsService.CROSS_SECTION);
    this.crossSectionService.performCrossSection();
  }
  cancelWindow():void{
    this.horizonToolController.cancelWindow();
    if (this.horizonToolController.errorMessage[0] != null){
      this.horizonToolController.horizonModal.minDepth = 1.0;
      this.horizonToolController.errorMessage[0] = null;
    }
    if (this.horizonToolController.errorMessage[1] != null){
      this.horizonToolController.horizonModal.maxDepth = 50.0;
      this.horizonToolController.errorMessage[1] = null;
    }
    if (this.horizonToolController.errorMessage[2] != null){
      this.horizonToolController.horizonModal.minStep = 1.0;
      this.horizonToolController.errorMessage[2] = null;
    }
    if (this.horizonToolController.errorMessage[3] != null){
      this.horizonToolController.horizonModal.heigthAboveTerrain = 3.0; // meters
      this.horizonToolController.errorMessage[3] = null;
    }



  }


}
